import { GameTypeAbstract } from "../GameTypeAbstract";

export class DefaultTableTypeAbstract extends GameTypeAbstract {
}
